<template>
  <span class="config-status" :class="`_${status}`" v-tooltip="{ content: $t(`satellites.config_status.${status}_hint`), triggers: ['hover', 'click'] }">
    {{ $t(`satellites.config_status.${status}`) }}
  </span>
</template>
<script>
// Whether the agent has applied the current settings: synced / pending / unknown / unsupported.
export default {
  name: "ConfigStatus",
  props: {
    status: {
      type: String,
      default: "unknown",
    },
  },
};
</script>
<style lang="scss" scoped>
.config-status {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  color: #6f6f78;
  background: #f1f1f4;

  &._synced {
    color: #37807d;
    background: #e3f1f1;
  }

  &._pending {
    color: #a86a00;
    background: #fff4dc;
  }

  &._unsupported {
    color: #c62424;
    background: #fbe7e7;
  }
}

body.dark .config-status {
  color: #b5b5bd;
  background: #2f2f35;

  &._synced {
    color: #6fc3c4;
    background: #1f3535;
  }

  &._pending {
    color: #f0b44c;
    background: #3a3020;
  }

  &._unsupported {
    color: #f07a7a;
    background: #3d2323;
  }
}
</style>
